import React, { useEffect, useState } from "react";
import { useFindingDetails } from "./FindingDetailsProvider";
import ACButton from "ac-components/ac-button/ACButton";


function RemediateByTool() {
  const { finding } = useFindingDetails();
  const [mobbFixAvailable, setIsMobbFixAvailable] = useState(false);
  const [mobbFixUrl, setMobbFixUrl] = useState("#");


  useEffect(() => {
    if (finding?.additionalDetails && finding.additionalDetails.mobbFixUrl) {
      setIsMobbFixAvailable(true);
      setMobbFixUrl(finding.additionalDetails.mobbFixUrl);
    }
  }, [finding?.additionalDetails]);



  return (
    <>
      <div className="m-b-l">
        Instantly generate and apply a secure code fix for this issue. You can review and approve the changes before they are committed.
      </div>
        <ACButton type="primary" disabled={!mobbFixAvailable}>
          <a href={mobbFixUrl} target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noreferrer" disabled ={!mobbFixAvailable}>
            Remediate with Mobb Fixer
          </a>
        </ACButton>
    </>
  );
}

export default RemediateByTool;
